export const selectSeoPageGroups = (state) => state.pageGroups;
export const selectSeoPagesSettings = (state) => state.pagesSettings;
export const selectSeoSocialMediaConfig = (state) => state.socialMediaConfig;
export const selectSeoSchemaMarkup = (state) => state.schemaMarkup;
export const selectSeoRobots = (state) => state.robots;
